import { TableCell, TableRow } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";
import { CustomColumnDef } from "@/components/data-table/types/custom-column-def";
import { CustomColumnMeta } from "@/components/data-table/types/custom-column-meta";
import ToneOfVoice from "@/models/tone-of-voice/toneOfVoice";

const SKELETON_WIDTH: Record<string, string> = {
  title: "w-32",
  description: "w-[75%]",
  isDefault: "w-16",
  delete: "w-8",
};

export const ToneOfVoiceRowSkeleton = ({
  columns,
}: {
  columns: CustomColumnDef<ToneOfVoice>[];
}) => {
  return (
    <TableRow>
      {columns.map((column, index) => {
        const key =
          "accessorKey" in column ? String(column.accessorKey) : String(index);
        const meta = column.meta as CustomColumnMeta | undefined;
        return (
          <TableCell key={key} className={meta?.cellClassName}>
            <div className="min-h-12 flex items-center">
              <Skeleton
                className={`h-4 ${SKELETON_WIDTH[key] ?? "w-24"} ${
                  key === "delete" ? "h-8 rounded-md" : ""
                }`}
              />
            </div>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
